export const normalizeUrl = (url: string) => {
  if (!url) return "";
  let fixedUrl = url.trim();

  // Return immediately if it's a blob or data URI
  if (fixedUrl.startsWith('blob:') || fixedUrl.startsWith('data:')) {
    return fixedUrl;
  }

  // Add protocol if missing
  if (!/^https?:\/\//i.test(fixedUrl)) {
    fixedUrl = `https://${fixedUrl}`;
  }

  // Only encode spaces, not already-encoded ones
  fixedUrl = fixedUrl.replace(/ /g, "%20");

  return fixedUrl;
};
